import { LogoMark } from "./Logo";
import { scrollToId, waLink, WHATSAPP_DISPLAY } from "@/data/site";

const links = [
  { label: "Início", href: "#inicio" },
  { label: "Benefícios", href: "#beneficios" },
  { label: "Planos", href: "#planos" },
  { label: "Depoimentos", href: "#depoimentos" },
  { label: "FAQ", href: "#faq" },
];

export const Footer = () => (
  <footer className="border-t border-white/5 py-12" data-testid="footer">
    <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-8 px-5 sm:px-8 md:flex-row md:items-center">
      <div className="flex items-center gap-3">
        <LogoMark className="h-8 w-8" />
        <div>
          <p className="font-display text-lg font-bold uppercase tracking-wide text-white">
            Flash Play <span className="text-neon">TV</span>
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-mist">
            Sua TV sem travamento
          </p>
        </div>
      </div>

      <nav className="flex flex-wrap items-center gap-6">
        {links.map((l) => (
          <button
            key={l.href}
            onClick={() => scrollToId(l.href)}
            data-testid={`footer-link-${l.href.slice(1)}`}
            className="font-mono text-[11px] uppercase tracking-[0.2em] text-mist transition-colors hover:text-neon"
          >
            {l.label}
          </button>
        ))}
      </nav>

      <div className="text-left md:text-right">
        <a
          href={waLink("Olá! Vim pelo site da Flash Play TV.")}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-whatsapp-link"
          className="font-mono text-sm text-white transition-colors hover:text-wa"
        >
          {WHATSAPP_DISPLAY}
        </a>
        <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.2em] text-mist">
          © {new Date().getFullYear()} Flash Play TV
        </p>
      </div>
    </div>
  </footer>
);
